import { defineMessages } from "react-intl";

const messages = defineMessages({
  Article: {
    id: "components.BookmarkRecommendation.article",
    defaultMessage: "Article"
  },
  Product: {
    id: "components.BookmarkRecommendation.product",
    defaultMessage: "Product"
  }
});

export default messages;
